/// <amd-module name="Test/Analytics/Common/Utils/ConfigurationUtility" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { FilterState } from "Test/common-util/Contracts/Filters";
import { areFilterStatesEqual } from "Test/common-util/TestResults.Filtering.Common";

export class ConfigurationUtility {
    private static arrayContains<S, T>(value: S, target: T[], comparer?: (s: S, t: T) => boolean): boolean {
        if (!target) {
            return false;
        }

        for (let i = 0, len = target.length; i < len; i++) {
            if (comparer && comparer(value, target[i])) {
                return true;
            }
        }

        return false;
    }

    private static arrayEquals<S, T>(
        source: S[],
        target: T[],
        comparer?: (s: S, t: T) => boolean,
        nullResult: boolean = false,
        sorted: boolean = false
    ): boolean {
        if (!source || !target) {
            return nullResult;
        }

        if (source.length !== target.length) {
            return false;
        }

        if (!sorted) {
            // TODO: Optimize this as it might result a lot of operation for large arrays.
            for (let i = 0, len = source.length; i < len; i++) {
                if (!ConfigurationUtility.arrayContains(source[i], target, comparer)) {
                    return false;
                }
            }
        } else {
            for (let i = 0, len = source.length; i < len; i++) {
                if (!comparer || !comparer(source[i], target[i])) {
                    return false;
                }
            }
        }

        return true;
    }

    private static _testOutComeArrayComparer = (a: CommonTypes.TestOutcome, b: CommonTypes.TestOutcome) => a === b;

    public static areConfValuesEqual(
        confValues1: CommonTypes.IReportConfiguration | undefined,
        confValues2: CommonTypes.IReportConfiguration | undefined
    ): boolean {
        if (!confValues1 && !confValues2) {
            return true;
        }

        if (!confValues1 || !confValues2) {
            return false;
        }

        if (confValues1.groupBy !== confValues2.groupBy) {
            return false;
        }

        if (confValues1.period !== confValues2.period) {
            return false;
        }

        if (confValues1.outcomes && confValues2.outcomes) {
            if (
                !ConfigurationUtility.arrayEquals<CommonTypes.TestOutcome, CommonTypes.TestOutcome>(
                    confValues1.outcomes,
                    confValues2.outcomes,
                    ConfigurationUtility._testOutComeArrayComparer,
                    false,
                    false
                )
            ) {
                return false;
            }
        }

        if ((confValues1.outcomes && !confValues2.outcomes) || (!confValues1.outcomes && confValues2.outcomes)) {
            return false;
        }
        return areFilterStatesEqual(confValues1.configuredFilters, confValues2.configuredFilters);
    }

    public static areFiltersApplied(configuredFilters: FilterState): boolean {
        if (configuredFilters) {
            for (const key of Object.keys(configuredFilters)) {
                if (configuredFilters[key].values && configuredFilters[key].values.length > 0) {
                    return true;
                }
            }
        }
        return false;
    }
}
